/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  /*
   * ==========================================================
   * CAB MINI-CART DISCOUNT LABEL
   * ==========================================================
   *
   * CAB Warehouse outputs:
   *
   * <li class="mini-cart__discount">
   *   <svg>...</svg>
   *   Volume Discount (-£119.00)
   * </li>
   *
   * We only replace:
   *
   * Volume Discount
   *
   * with:
   *
   * Discount
   *
   * The dynamically generated discount amount remains untouched.
   */

  const MINI_CART_DISCOUNT_SELECTOR =
    '#mini-cart .mini-cart__discount';


  function shortenMiniCartDiscounts() {
    document
      .querySelectorAll(
        MINI_CART_DISCOUNT_SELECTOR
      )
      .forEach(function (discount) {

        Array
          .from(discount.childNodes)
          .forEach(function (node) {

            /*
             * Ignore the SVG and any other elements.
             * We only want the plain text node.
             */

            if (
              node.nodeType !== Node.TEXT_NODE ||
              !node.nodeValue
            ) {
              return;
            }


            /*
             * Example:
             *
             * Volume Discount (-£119.00)
             *
             * becomes:
             *
             * Discount (-£119.00)
             */

            if (
              node.nodeValue.includes(
                'Volume Discount'
              )
            ) {
              node.nodeValue =
                node.nodeValue.replace(
                  'Volume Discount',
                  'Discount'
                );
            }
          });
      });
  }


  /*
   * ==========================================================
   * SCHEDULE UPDATES
   * ==========================================================
   *
   * Warehouse may rebuild the mini-cart when products
   * or quantities change, so we reapply the wording after
   * those dynamic updates.
   */

  let updateScheduled = false;


  function scheduleMiniCartUpdate() {
    if (updateScheduled) {
      return;
    }

    updateScheduled = true;

    requestAnimationFrame(
      function () {
        updateScheduled = false;

        shortenMiniCartDiscounts();
      }
    );
  }


  /*
   * ==========================================================
   * WATCH MINI-CART FOR DYNAMIC CHANGES
   * ==========================================================
   */

  function mutationTouchesMiniCart(
    mutation
  ) {

    /*
     * Existing text changed.
     */

    if (
      mutation.type ===
      'characterData'
    ) {
      const parent =
        mutation.target.parentElement;

      return !!(
        parent &&
        parent.closest('#mini-cart')
      );
    }


    /*
     * Warehouse inserted/replaced DOM elements.
     */

    if (
      mutation.type ===
      'childList'
    ) {

      if (
        mutation.target instanceof Element &&
        mutation.target.closest('#mini-cart')
      ) {
        return true;
      }


      return Array
        .from(
          mutation.addedNodes
        )
        .some(function (node) {

          if (
            !(node instanceof Element)
          ) {
            return false;
          }

          return (
            node.matches('#mini-cart') ||
            node.matches('.mini-cart__discount') ||
            node.querySelector('#mini-cart') !== null ||
            node.querySelector('.mini-cart__discount') !== null
          );
        });
    }

    return false;
  }


  /*
   * ==========================================================
   * INITIALISE
   * ==========================================================
   */

  function initialiseCabCustomisations() {

    /*
     * Run once against the mini-cart already
     * present when the page loads.
     */

    shortenMiniCartDiscounts();


    /*
     * Watch Warehouse for subsequent mini-cart redraws.
     */

    const observer =
      new MutationObserver(
        function (mutations) {

          if (
            mutations.some(
              mutationTouchesMiniCart
            )
          ) {
            scheduleMiniCartUpdate();
          }
        }
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );


    /*
     * Warehouse cart events.
     */

    document.addEventListener(
      'product:added',
      scheduleMiniCartUpdate
    );

    document.addEventListener(
      'cart:refresh',
      scheduleMiniCartUpdate
    );
  }


  /*
   * ==========================================================
   * START
   * ==========================================================
   */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseCabCustomisations,
      {
        once: true
      }
    );
  } else {
    initialiseCabCustomisations();
  }

})();